import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
export var PermsClient = /*#__PURE__*/function (_RestClient) {
  _inherits(PermsClient, _RestClient);
  var _super = _createSuper(PermsClient);
  function PermsClient() {
    _classCallCheck(this, PermsClient);
    return _super.apply(this, arguments);
  }
  _createClass(PermsClient, [{
    key: "getIsSiteAdmin",
    value: function getIsSiteAdmin(
    /**
     * @private
     * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
     */
    cloudId) {
      return this.postResource('/permitted', {
        permissionId: 'manage',
        resourceId: "ari:cloud:platform::site/".concat(this.getCloudId(cloudId))
      }).then(function (response) {
        return response.permitted;
      });
    }
  }]);
  return PermsClient;
}(RestClient);

/**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default new PermsClient({
  serviceUrl: DEFAULT_CONFIG.permsServiceUrl
});